import { Link } from 'react-router-dom';
import { BLOG_ENABLED } from '../../config/blogConfig';
import './footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-grid">

          <div className="footer-col">
            <h4>Our Services</h4>
            <ul>
              <li><Link to="/public-speaking">Public Speaking</Link></li>
              <li><Link to="/digital-marketing">Digital Marketing</Link></li>
              <li><Link to="/web-design">Web Design</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              {BLOG_ENABLED && <li><Link to="/blogs">Blog</Link></li>}
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-col contact-col">
            <h4>Contact Us</h4>
            <p><i className="fas fa-map-marker-alt"></i>Unit 5 Vision 85, Clonminam Business Park R32 F5T6</p>
            <p><i className="fas fa-phone-alt"></i> 087 383 1780</p>
            <p><i className="fas fa-envelope"></i> enquiries@aokmentoring.com</p>
          </div>

          <div className="footer-col footer-socials-col">
            <h4>Follow Us</h4>
            <a href="https://www.instagram.com/aokmentoring" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i> Instagram
            </a>
            <a href="https://www.linkedin.com/in/alison-o-kelly-4a927626b/" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-linkedin-in"></i> LinkedIn
            </a>
          </div>

        </div>

        <p className="footer-copy">&copy; {new Date().getFullYear()} AOK Communications. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
